import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { Cls_MobiAsideMenuItems, SideNavService } from "@mobi-office-ui";

@Component({
    selector: "mobi-office-custom-aside-section",
    templateUrl: "./custom-aside-section.component.html",
    styleUrl: "./custom-aside-section.component.scss",
    standalone: false
})
export class CustomAsideSectionComponent {
  @Input() menuItems: Cls_MobiAsideMenuItems[] = [];
  @Output() tabEmitter = new EventEmitter();

  constructor(
    private router: Router,
    private sideNavService: SideNavService
  ) {}

  onTabChange(tab: any) {
    this.router.navigate([tab.URL]);
    this.sideNavService.close();
  }

  // isActiveRoute(menu: Cls_MobiAsideMenuItems): boolean {
  //   return this.router.url.startsWith(menu.pageUrl || "");
  // }

  isActiveRoute(menu: Cls_MobiAsideMenuItems): boolean {
    return this.router.isActive(menu.pageUrl || "", false);
  }
}
